import React, {useMemo, useRef, useState} from 'react';
import dayjs from "dayjs";
import {Button, Input, Space, Tag} from "antd";
import {Sorter} from "../../shared/components/Sorter";
import TablePage from "../../pages/tablePage/TablePage";
import CustomDateTimePicker from "../../shared/components/date/CustomDateTimePicker";
import {buildUrl} from "../../shared/utils/net";
import {handleKeyDown} from "../../shared/utils/basic";
import {ShopPackageEntity} from "../storeManager/ShopPackageEntity";
import {internalApi} from "../../common/axios";
import toast from "react-hot-toast";
import GoToUserInfoButton from "../../shared/components/buttons/GoToUserInfoButton";

const banStateTag = (state) => {
    const map = {
        0: {label: '정상', color: 'green'},
        1: {label: '탈퇴', color: 'red'},
        4: {label: '정지', color: 'yellow'},
    };
    const info = map[state];
    return info ? <Tag color={info.color}>{info.label}</Tag> : <Tag>{state}</Tag>;
};

const defaultParams = {
    begin: dayjs().subtract(1, 'week').startOf('day').format('YYYY-MM-DD HH:mm:ss'),
    end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
    isUnix: false,
    banUserPid: '',
};

const BanLog = () => {
    const [searchParam, setSearchParam] = useState(defaultParams);
    const [url, setUrl] = useState(buildUrl('logs/ban', defaultParams));
    const [rowData, setRowData] = useState({});
    const [rows, setRows] = useState([]);
    const refreshRef = useRef(null);

    const handleSearchChange = (name, value) => {
        setSearchParam(prev => ({...prev, [name]: value}));
    };

    const handleSearch = () => {
        setUrl(buildUrl('logs/ban', searchParam));
    };

    const handleMemoSave = (record, memo) => {
        console.log('Saving memo for record:', record.seq, 'with memo:', memo);

        internalApi.post('logs/ban/memo', {seq: record.seq, memo}).then((res) => {
            toast.success(res.data.message);
        }).catch((err) => {
            console.error(err);
            toast.error("메모 저장 실패");
        });
    }

    const columns = useMemo(() => ([
        {
          title: 'seq',
            dataIndex: 'seq',
        },
        {
            title: '서버 환경',
            dataIndex: 'banEnv',
        },
        {
            title: 'PID',
            dataIndex: 'banUserPid',
            search: true,
        },
        {
            title: '제재 상태',
            dataIndex: 'banState',
            render: (state) => banStateTag(state),
        },
        {
            title: '제재 기한',
            dataIndex: 'banExpiryDate',
            render: (time) => dayjs(time).format('YYYY-MM-DD HH:mm:ss'),
            sorter: (a, b) => Sorter.DATE(a.banExpiryDate, b.banExpiryDate),
        },
        {
            title: '제재 담당자',
            dataIndex: 'banAdminId',
            search: true,
        },
        {
            title: '제재일',
            dataIndex: 'created',
            render: (time) => dayjs(time).format('YYYY-MM-DD HH:mm:ss'),
            sorter: (a, b) => Sorter.DATE(a.created, b.created),
        },
        {
            title: '메모',
            dataIndex: 'memo',
            render: (_, row) => {
                return (<Input
                    key={`memo-${row.seq} || ''}`}
                    type="text"
                    defaultValue={ row.memo }
                    style={{ width: '100%' }}
                    onBlur={(e) => handleMemoSave(row, e.target.value)}
                    onPressEnter={(e) => handleMemoSave(row, e.target.value)}
                />);
            }
        },
        {
            title: '유저 정보',
            dataIndex: 'banUserPid',
            render: (banUserPid) => <GoToUserInfoButton pid={banUserPid} />,
        }
    ]), []);

    return (
        <div>
            <div className='search-params'>
                <Space>
                    <CustomDateTimePicker
                        rows={searchParam}
                        handleSetRows={handleSearchChange}
                        isUnixTime={false}
                        hasTime={false}
                        hasAdd={false}
                    />
                    <Input
                        placeholder="PID 검색"
                        value={searchParam.banUserPid}
                        onChange={(e) => handleSearchChange('banUserPid', e.target.value)}
                        onKeyDown={(e) => handleKeyDown(e, handleSearch)}
                        style={{width: 200}}
                    />
                    <Button onClick={handleSearch}>Search</Button>
                </Space>
            </div>
            <TablePage
                columns={columns}
                rowData={rowData}
                setRowData={setRowData}
                setRows={setRows}
                refreshRef={refreshRef}
                url={url}
                searchParam={searchParam}
            />
        </div>
    );
};

export default BanLog;
